import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../modules/auth/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private routes: Router, private auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }
    // else{
    //     const urlTree = this.routes.parseUrl(this.routes.url);
    //     const urlWithoutParams = urlTree.root.children["primary"].segments
    //       .map(it => it.path)
    //       .join("/");

    //       if(urlWithoutParams != 'login'){
    //           this.auth.logout();
    //           this.routes.navigate(['/login']);
    //       }

    // }
    return next.handle(request);
  }
}
